import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext';
import BackLoader from '../components/backloader';
import JisButton from '../components/controls/jisButton';
import CaseSearch from '../components/core/case_search';
import moment from 'moment'

function ESwearing() {
   const {  activePage, token, profile,frequentData,setIsExpired} = useContext(ShareContext);

   
    
    const [docs, setDocs] = useState([]);
    const [cases, setCases]=useState([]);
    const [refs, setRefs]=useState([]);;
    const [loading,setLoading]= useState(false);
    const [casetype, setCaseType] = useState('litigation');
   const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState({});
    const [tab,setTab]=useState('pending');
    const [err, setErr]=useState('');

    const navigate = useNavigate();
    
    
       useEffect(() => {
           
                if(pageIndex>=0){
                   if(search!=null){
                     onSearch(search);
                   }
                 }else{
                   setPageIndex(0);
                 }           
               }, [pageIndex,pageSize,search]);


      const onLoad= async()=>{
        //for account registration
        
        var url=`${Constants.apiUrl}/filing/my-eswearing-cases/${tab}/${pageIndex}/${pageSize}`
       
        try {
            setLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                 Authorization: `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
            if(data.code==0){

            }
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                setCases(data.items);
               
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else {    
                alert(data.status);
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    }
 
   

     const onView=(item)=>{   
          navigate(`/prepare-document/${item.docupload[0].id}/legal`);     
     }

      const onSearch=async(sear)=>{ 
                 setSearch(sear)       ;
                 setLoading(true)
                 try {
                 
                 const resp = await fetch(`${Constants.apiUrl}/filing/my-eswearing-cases/${tab}/${pageIndex}/${pageSize}`, {
                     method: 'POST',
                     body:JSON.stringify(sear) ,
                     headers: {
                     'Content-Type': 'application/json, text/plain',
                     Authorization: `Bearer ${token}`,
                     },
                 });
                 
                 const data = await resp.json();
                 setLoading(false);
                 console.log(data);
                 if(data.code==0){
                 //update the field
                    setCases(data.items);
                 } else if(data.code==-10){
                      setIsExpired(true);
                  }else{
                 //there is an error
                 setErr(data.status);
                 }
                 
                 } catch (error) {
                 setLoading(false);
                 console.error(error);
                 setErr(Constants.serverErr);
                 // onMove();
                 }
             }

   
  return (
    <div >
    
        <div >
           <CaseSearch onSearch={onSearch} frequentData={frequentData} />

            <div className="table">
                <div class="section-cases">
                <span>E-Swearing Cases</span>
                </div>
                <table class="case-table">
                    <thead>
                        <tr>
                            {/* <th>ID</th> */}
                            
                            <th>Suite Number</th>
                            <th> Title</th>
                            <th>Document Count</th>
                            <th>Status</th>
                            <th>Schedule Date and Time</th>
                            <th>Zoom Link</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        { cases?.map((item, id) => { return (
                            <tr key={id}>
                               {/*  <td>{item.id}</td> */}
                                <td>{item.case.caseNumber?? item.case.referenceNumber}</td>
                                <td>{item.case.caseTitle}</td>
                                <td >{item.linecount}</td>
                                <td>{item.isCompleted?'Process Completed':'Pending Upload/Oath'}</td>
                                <td className={ item.docupload[0]?.schedule!=null ?'date-time' : 'date-time pends'}>{item.docupload[0]?.schedule!=null ? moment(item.docupload[0]?.schedule).format("dddd, MMMM Do YYYY h:mm a")  : 'No scheduled date'}</td>
                              <td className={item.docupload[0]?.schedule!=null ? 'zoom' : 'zoom pends'}>{item.docupload[0]?.zoomLink!=null && <a href={item.docupload[0]?.zoomLink} target='_blank'> Zoom Link </a>} </td>
                                <td > <JisButton  variant='plain' className='black' onClick={()=>onView(item)}>View Documents Attached</JisButton></td>
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>
            
        </div>
        <BackLoader open={loading}  />
    </div>
  )
}

export default ESwearing